import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthorizationService } from './authorization.service'; // Adjust path as needed

@Injectable({
  providedIn: 'root'
})
export class CanLoadTapToActivateGuard implements CanActivate {
  
  constructor(
    private authorizationService: AuthorizationService,
    private router: Router
  ) {}

  canActivate(): boolean {
    try {
      return true;
    } catch (error) {
      console.error('Error in ApiCustomerGuard:', error);
      this.handle404();
      return false;
    }
  }

  private handle404(): void {
    this.router.navigate(['/page-not-found']);
  }
}